@if (configuration.display) {
<div class="featured-detail-container">
    @for (item of configuration.items; track item) { @if (data &&
    data[item.key]) {
    <div class="featured-detail-item is-bordered is-rounded">
        <div class="featured-detail-items-inner">
            <img
                [src]="item.image_src"
                [alt]="getImgAltText(item)"
                loading="lazy"
            />
            <div class="featured-detail-content">
                @if (item.title) {
                <p class="featured-detail-title">
                    {{ item.title | rasTemplate : data }}
                </p>
                } @if (item.subtitle && !item.subtitle_link) {
                <p class="featured-detail-subtitle is-color-opacity-secondary">
                    {{ item.subtitle | rasTemplate : data }}
                </p>
                } @else {
                <p
                    class="featured-detail-subtitle featured-detail-link is-color-primary"
                    [routerLink]="item.subtitle_link"
                    [queryParams]="getParams(item.subtitle_link_params)"
                >
                    {{ item.subtitle | rasTemplate : data }}
                </p>
                }
            </div>
        </div>
    </div>
    } }
</div>
}
